import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PhoneIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fill='currentColor'
            fillRule='evenodd'
            clipRule='evenodd'
            d='M6.11995 10.6672C6.92138 12.2003 7.94057 13.5854 9.17755 14.8224C10.4145 16.0593 11.7996 17.0785 13.3328 17.88L15.737 15.4757C15.8764 15.3189 16.0506 15.2144 16.2597 15.1621C16.4688 15.1098 16.6691 15.1272 16.8608 15.2144C18.0106 15.6151 19.2999 15.8154 20.7285 15.8154C21.0247 15.8154 21.2773 15.92 21.4864 16.129C21.6954 16.3381 21.7999 16.5907 21.7999 16.8869V20.7285C21.7999 21.0247 21.6954 21.2773 21.4864 21.4864C21.2773 21.6954 21.0247 21.7999 20.7285 21.7999C18.2197 21.7999 15.8154 21.3121 13.5157 20.3365C11.3031 19.3957 9.34307 18.0716 7.63568 16.3642C5.9283 14.6568 4.60422 12.6969 3.66342 10.4842C2.68777 8.18447 2.19995 5.78023 2.19995 3.27142C2.19995 2.97524 2.30448 2.72262 2.51355 2.51355C2.72262 2.30448 2.97524 2.19995 3.27142 2.19995H7.11302C7.4092 2.19995 7.66182 2.30448 7.87088 2.51355C8.07995 2.72262 8.18448 2.97524 8.18448 3.27142C8.18448 4.70005 8.38484 5.98928 8.78555 7.13915C8.83782 7.3308 8.84653 7.53115 8.81168 7.74022C8.77684 7.94929 8.68102 8.12351 8.52422 8.26289L6.11995 10.6672Z'
        />
    ),
})

PhoneIcon.displayName = 'PhoneIcon'
